import React, { useContext } from 'react'

import StoreContext from '~/context/StoreContext'
import LineItem from './LineItem';
import { useIntl,Link } from "gatsby-plugin-intl";

const currencyMapper = {
  "price_uk":"£",
  "price_sek":"SEK",
  "price_eu":"€"
}

const Cart = () => {
  const {
    store: { checkout },
  } = useContext(StoreContext)


  let totalPrice = 0;
  const intl = useIntl();
  const currencyKey = intl.formatMessage({ id: "price_key" });
  const line_items = checkout.lineItems.map(line_item => {
    console.log(line_item)

    line_item.customAttributes.map( item  =>{
      if(item.key == currencyKey){
        totalPrice += parseFloat(item.value)*parseFloat(line_item.quantity);
      }
     })
    return <LineItem key={line_item.id.toString()} line_item={line_item} />
  })

  return (
    <div>
      {line_items}
      <h2>Total</h2>
      <p>{currencyMapper[currencyKey]} {totalPrice}</p>
      <br />
      <Link to="/checkout/" disabled={checkout.lineItems.length === 0}>Check Out</Link>
    </div>
  )
}

export default Cart
